export default "__VITE_ASSET__Bb$O47QQ__";